<template>
  <div class="result-box">
    <div class="zhezhao" v-if="resultText == 3">
      <div class="confirm-box">
        <div class="title">请确认支付是否已完成</div>
        <div class="result" @click="getResult">已完成支付</div>
        <div class="wenti" @click="navToPayMent">支付遇到问题，重新支付</div>

      </div>
    </div>

    <div class="result-text" v-if="resultText == 2">
      <van-icon name="warning" color="#F76260" class="icon-size" />
      <div class="title">订单支付失败</div>
      <div class="tips">请在 <span class="date">30分钟</span>内完成付款</div>

      <div class="cancel-text">否则订单将会被系统取消</div>
      <div class="btn-box">
        <div @click="navToOrderlist">查看订单</div>
        <div @click="navToPayMent2">重新付款</div>
      </div>
    </div>
    <div class="result-text" v-if="resultText == 1">
      <van-icon name="checked" class="icon-size" color="#30BB07" />
      <div class="title">订单支付成功</div>
      <div class="btn-box">
        <div @click="navToOrderlist">查看订单</div>
        <div @click="navToIndex">回到首页</div>
      </div>
    </div>
  </div>

</template>

<script>
import { findWxOrderStatus, findAliOrderStatus } from "@/api/index";
// import itemInfo from "@/components/itemInfo";
import { Dialog } from "vant";

export default {
  name: "paymentResult",

  data() {
    return {
      hasAddress: true,
      value: "",
      resultText: 3,
    };
  },
  mounted() {
    // localStorage.removeItem("wxxxx");
  },

  methods: {
    getResult() {
      let ordernum = localStorage.getItem("paynum");
      let orderType = localStorage.getItem("paytype");

      if (orderType == "wx") {
        findWxOrderStatus(ordernum).then((res) => {
          if (res.data.data.code == "1") {
            this.resultText = 1;
            Dialog.confirm({
              title: "提示",
              message: "已经支付成功哦",
            })
              .then(() => {
                // on confirm
                this.$router.push({
                  path: "/myorders/0",
                });
              })
              .catch(() => {
                // on cancel
                this.$router.push({
                  path: "/myorders/0",
                });
              });

            localStorage.removeItem("paynum");
            localStorage.removeItem("paytype");
          } else {
            this.resultText = 2;
          }
        });
      } else if (orderType == "ali") {
        findAliOrderStatus(ordernum).then((res) => {
          if (res.data.data.code == "1") {
            this.resultText = 1;
            Dialog.confirm({
              title: "提示",
              message: "已经支付成功哦",
            })
              .then(() => {
                // on confirm
                this.$router.push({
                  path: "/myorders/0",
                });
              })
              .catch(() => {
                // on cancel
                this.$router.push({
                  path: "/myorders/0",
                });
              });
            localStorage.removeItem("paynum");
            localStorage.removeItem("paytype");
          } else {
            this.resultText = 2;
          }
        });
      } else {
        Dialog.confirm({
          title: "提示",
          message: "此订单或已支付，请前往订单中心查看。",
        })
          .then(() => {
            // on confirm
            this.$router.push({
              path: "/myorders/0",
            });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    navToOrderlist() {
      this.$router.push({
        path: "/myorders/0",
      });
    },
    navToIndex() {
      this.$router.push({
        path: "/index",
      });
    },
    navToPayMent() {
      this.getResult();
    },
    navToPayMent2() {
      this.$router.push({
        path: "/type/payment",
        query: {
          orderId: localStorage.getItem("paynum"),
          price: localStorage.getItem("orderPrice"),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.zhezhao {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;

  .confirm-box {
    height: 18rem;
    width: 90%;
    background: #fff;
    border-radius: 22px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    padding: 1rem 0;
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #424242;
      line-height: 5rem;
      font-weight: 600;
      height: 5rem;
      border-bottom: 1px solid #eee;
      width: 100%;
    }
    .result {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #a9936b;
      letter-spacing: 0;
      text-align: center;
      line-height: 4rem;
      margin: 1rem 0;
      height: 4rem;
      border-bottom: 1px solid #eee;
      width: 90%;
    }
    .wenti {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #424242;
      line-height: 4rem;
      height: 4rem;
      border-bottom: 1px solid #eee;
      width: 90%;
    }
  }
}
.result-box {
  height: 100%;
  /*控制底部滚动*/
  overflow-y: scroll;
  .result-text {
    .title {
      /* color: salmon; */
      margin: 1.3rem auto 2.4rem;
      /* font-size: 1.6rem; */
      font-family: PingFangSC-Semibold;
      font-size: 2rem;
      color: #222b45;
      text-align: center;
      line-height: 2rem;
    }
    .tips {
      margin-bottom: 1rem;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      text-align: center;
      line-height: 1.8rem;
      span {
        font-family: PingFangSC-Regular;
        font-size: 1.4rem;
        color: #fb5c49;
        letter-spacing: 0;
        text-align: center;
        line-height: 1.8rem;
      }
    }
    .cancel-text {
      font-size: 1.4rem;
      margin-bottom: 1rem;
    }
    .btn-box {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      padding: 3rem 7rem;

      div {
        padding: 1.2rem 2.8rem;
        border: 1px solid #d9d9d9;
        border-radius: 20px;
      }
    }
  }
}
.icon-size {
  font-size: 8rem;
  margin-top: 3.9rem;
}
</style>



// WEBPACK FOOTER //
// src/view/type/paymentResult.vue